<template>
  <div v-if="dataPermission.includes('CNPS_DEVICE_ORDER_IMPORT_VIEW')">
    <div v-if="item">
      <div class="breadcrumb-area pos-relative w-100">
        <h1>Chi tiết phiếu nhập kho</h1>
        <div class="btn-group float-right">
          <button
            type="button"
            class="font-medium btn btn-outline-secondary"
            @click="$router.push('/import-warehouse')"
          >
            <i class="bx bx-exit"></i> Quay lại
          </button>
          <button class="btn font-medium btn-outline-secondary" @click="inTicket(item.id)">
            <i class="bx bx-copy"></i><span>&nbsp;</span>In phiếu
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="canEdit(item.status, item.userCreator)"
            @click="editItem(item.id)"
          >
            <i class="bx bx-pencil"></i><span>&nbsp;</span>Sửa
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="canApprove(item.status, item.managerIdInventory)"
            @click="approveItem(item)"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span>Duyệt
          </button>
          <button
            v-if="canReject(item.status, item.managerIdInventory)"
            class="btn font-medium btn-outline-secondary"
            @click="rejectItem(item)"
          >
            <i class="bx bx-x-circle"></i><span>&nbsp;</span>Từ chối
          </button>
          <button
            v-if="canCancel(item.status, item.userCreator, item.managerIdInventory)"
            class="btn font-medium btn-outline-secondary"
            @click="cancelItem(item)"
          >
            <i class="bx bxs-trash"></i><span>&nbsp;</span>Huỷ
          </button>
          <button
            v-if="canCoppy(item.status, item.userCreator)"
            class="btn font-medium btn-outline-secondary"
            @click="copyItem(item.id)"
          >
            <i class="bx bx-copy"></i><span>&nbsp;</span>Tạo bản copy
          </button>
          <button
            v-if="canEditDate(item.status, item.userCreator)"
            class="btn font-medium btn-outline-secondary"
            @click="editDate()"
          >
            <i class="bx bx-edit"></i><span>&nbsp;</span>Sửa ngày hoàn thành phiếu
          </button>
        </div>
      </div>
      <div class="card p-10 pt-15 b-t-1-869fb229">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-detail">
              <h1 class="form-inner-heading mb-1">Thông tin</h1>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Số phiếu nhập<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.billNumber }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Trạng thái<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    <span class="badge" :class="[item.status || '']">
                      {{ item.status | transformData(Config.statusImportWarehouse) }}
                    </span>
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Tên kho nhập<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p
                    class="form-control-plaintext f12 text-primary"
                    type="button"
                    @click="$router.push(`/cat-warehouse/${item.inventoryIdImport}`)"
                  >
                    {{ item.inventoryIdImport | transformData(warehouseData) }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Nhà cung cấp<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.supplier | transformData(supplierData) }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Lý do nhập<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.reasonImport | transformData(Config.reasonImportWarehouse) }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Ngày nhập<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.timeImport | formatDate }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Ngày tạo<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.dateCreate | formatDate }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Người tạo<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.userCreator.name }} - {{ item.userCreator.email }}
                  </p>
                </div>
              </div>

              <div
                class="form-group form-row"
                v-if="['APPROVED', 'REJECTED', 'CANCELLED'].includes(item.status)"
              >
                <label for="" class="col-sm-4 col-form-label">
                  Thời gian {{ getPersonAction(item.status) }}
                  <span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p v-if="item.status === 'APPROVED'" class="form-control-plaintext f12">
                    {{ item.timeApprove | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                  <p v-if="item.status === 'REJECTED'" class="form-control-plaintext f12">
                    {{ item.timeReject | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                  <p v-if="item.status === 'CANCELLED'" class="form-control-plaintext f12">
                    {{ item.timeCancel | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>

              <div
                class="form-group form-row"
                v-if="['APPROVED', 'REJECTED', 'CANCELLED'].includes(item.status)"
              >
                <label for="" class="col-sm-4 col-form-label">
                  Người {{ getPersonAction(item.status) }}
                  <span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p v-if="item.status === 'APPROVED'" class="form-control-plaintext f12">
                    {{ item.personApprove.name }} - {{ item.personApprove.email }}
                  </p>
                  <p v-if="item.status === 'REJECTED'" class="form-control-plaintext f12">
                    {{ item.personReject.name }} - {{ item.personReject.email }}
                  </p>
                  <p v-if="item.status === 'CANCELLED'" class="form-control-plaintext f12">
                    {{ item.personCancel.name }} - {{ item.personCancel.email }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row" v-if="item.status === 'REJECTED'">
                <label for="" class="col-sm-4 col-form-label">
                  Lý do từ chối<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.reasonReject }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Ghi chú<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{
                      item.description
                        ? item.description
                        : item.reasonImport
                          ? item.reasonImport
                          : item.reasonExport
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6"></div>
        </div>
        <div class="card pt-2 p-10">
          <div class="d-flex pos-relative w-100 justify-content-between mb-2">
            <h1 class="form-inner-heading mb-1">Bảng thông tin thiết bị</h1>
          </div>
          <div class="box-header">
            Tổng:
            <strong class="text-primary">{{ item.quantityImport }}</strong>
          </div>
          <div class="tab-content">
            <div class="table-responsive" style="overflow: auto; max-height: 70vh">
              <table class="table table-hover table-bordered">
                <thead class="thead-light">
                  <tr class="text-center">
                    <th>Tên thiết bị</th>
                    <th v-if="item.kindImport === 'NORMAL'">Số lượng</th>
                    <th v-if="item.kindImport === 'SERIAL'">Mã Serial</th>
                    <th>Số thùng</th>
                    <th>Ghi chú</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="table-row text-center"
                    v-for="(device, index) in item.devices"
                    :key="`device${index}`"
                  >
                    <td>{{ device.categoryName }}</td>
                    <td v-if="item.kindImport === 'NORMAL'">{{ device.quantity }}</td>
                    <td v-if="item.kindImport === 'SERIAL'">{{ device.serial }}</td>
                    <td>{{ device.numberGear }}</td>
                    <td>{{ device.noteImport }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="notiModal">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      @click="notiModal = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img :src="iconNoti" alt="icon-successs" />
                    <h2 class="f18 py-3">{{ msgNoti }}</h2>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="checkToActionModal(keyCheck)"
                      data-dismiss="modal"
                      v-if="keyCheck === 'accept' || keyCheck === 'back' || keyCheck === 'addLead'"
                    >
                      Đồng ý
                    </button>
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="notiModal = false"
                      data-dismiss="modal"
                      v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                    >
                      Bỏ qua
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <ChangeDate :id="entryId" @updateDateComplete="updateDateComplete" />
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  import mxItemAction from './mx-item-action.js'
  export default {
    mixins: [mxItemAction],
    data() {
      return {
        item: null,
        entryId: this.$route.params.entryId,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        Config,
        supplierData: [],
        warehouseData: [],
      }
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig?.find(e => e.id === data) ?? {}
        return dataReturn.text
      },
    },
    mounted() {
      this.$root.$on('bv::modal::hide', bvEvent => {
        if (bvEvent.trigger === 'ok' && this.$refs.rejectValue) {
          if (!this.$refs.rejectValue.value.trim()) {
            this.showErr('Lý do nhập không được bỏ trống')
            bvEvent.preventDefault()
          } else if (
            this.$refs.rejectValue.value.trim().length < 2 ||
            this.$refs.rejectValue.value.trim().length > 255
          ) {
            this.showErr('Lý do nhập ký tự nhỏ nhất là 2 và lớn nhất là 255 ký tự')
            bvEvent.preventDefault()
          }
        }
      })
    },
    created() {
      this.fetchWarehouse()
      this.fetchSupplier()
      this.fetchData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      async fetchData() {
        try {
          this.loading = true
          const response = await DeviceService.detailImportWarehouse(this.entryId)
          if (response.code === 1000 || response.success) {
            this.item = response.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async fetchSupplier() {
        const response = await DeviceService.getListSupllier({
          limit: 1000,
          page: 1,
        })
        this.supplierData = response.data.map(({ id, name }) => {
          return { id, text: name }
        })
      },
      async fetchWarehouse() {
        const response = await DeviceService.getListSearchWarehouse()
        this.warehouseData = response.data.map(({ id, name }) => {
          return { id, text: name }
        })
      },
      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },
      showSuccess(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = message
      },
      getPersonAction(status) {
        if (status === 'APPROVED') return 'duyệt'
        if (status === 'REJECTED') return 'từ chối'
        return 'huỷ'
      },
      async updateDateComplete(data) {
        try {
          this.loading = true
          const response = await DeviceService.editDateComplete({
            id: this.entryId,
            date: data,
          })
          if (response.code === 1000 || response.success) {
            this.showSuccessMx('Cập nhật thành công!')
            this.$bvModal.hide('change-date')
            this.fetchData()
          } else this.showFailMx(response.message)
        } catch (error) {
          this.showFailMx(error.message)
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
